import {downloadPrivateMedia} from '../../helpers/privateMedia';
import {
    Button,
    Divider, InputAdornment,
    TextField,
    Toolbar,
    Typography,
    withWidth
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from '@material-ui/core/styles';
import clsx from "clsx";
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { logOut } from "../../helpers/logout";
import {getAccess} from "../../helpers/permissions";
import FlowiiService from "../../services/flowii.service";
import FunerioService from "../../services/funerio.service";
import UserService from "../../services/user.service";
import PhotoUploadCard from "./PhotoUploadCard";
import {photoFormData, photoUploadErrorMessage, validatePhotoFile} from '../../helpers/photo-upload';

import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { Redirect } from "react-router-dom";

import Tooltip from "@material-ui/core/Tooltip";
import AllInboxIcon from '@material-ui/icons/AllInbox';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DeleteIcon from "@material-ui/icons/Delete";
import DescriptionIcon from '@material-ui/icons/Description';
import EditIcon from '@material-ui/icons/Edit';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import PersonIcon from '@material-ui/icons/Person';
import PlaceIcon from '@material-ui/icons/Place';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import ShareIcon from '@material-ui/icons/Share';
import StorageIcon from '@material-ui/icons/Storage';
import { NotificationManager } from "react-notifications";
import Title from "../dashboard/Title";
import ActionButton from "../form/input/ActionButton";
import TextInput from "../form/input/TextInput";
import ConfirmDialog from "./ConfirmDialog";
import DocumentsDetails from "./DocumentsDetails";
import Popup from "./Popup";
import TaskDetails from "./TaskDetails";

const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: 'transparent',
    },
    seeMore: {
        marginTop: theme.spacing(6),
        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(3),
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
        },
    },
    paper: {
        padding: theme.spacing(4),
        display: 'flex',
        overflow: 'visible',
        flexDirection: 'column',
        background: '#ffffff',
        borderRadius: 14,
        border: '1px solid rgba(176, 141, 87, 0.16)',
        boxShadow: '0 6px 22px rgba(44, 71, 103, 0.06)',
        position: 'relative',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2.5),
            borderRadius: 10,
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 3,
            background: 'linear-gradient(90deg, #2c4767 0%, #b08d57 100%)',
            borderTopLeftRadius: 14,
            borderTopRightRadius: 14,
        },
    },
    fixedHeight: {
        height: 340,
    },
    tabsBar: {
        background: '#ffffff',
        borderRadius: 12,
        border: '1px solid rgba(176, 141, 87, 0.18)',
        boxShadow: '0 4px 16px rgba(44, 71, 103, 0.06)',
        marginBottom: theme.spacing(3),
        // Center the tab row when it fits, but still allow scrolling when it overflows.
        // Auto margins on the first/last tab collapse to 0 once the row overflows,
        // so scrolling reaches both edges. `justify-content: center` would clip the
        // leading tabs and make them unreachable.
        '& .MuiTabs-flexContainer > :first-child': {
            marginLeft: 'auto',
        },
        '& .MuiTabs-flexContainer > :last-child': {
            marginRight: 'auto',
        },
        '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.92rem',
            letterSpacing: 0.2,
            color: '#5a6675',
            minHeight: 64,
            transition: 'color 150ms ease, background 150ms ease',
        },
        '& .MuiTab-root:hover': {
            color: '#2c4767',
            background: 'rgba(176, 141, 87, 0.06)',
        },
        '& .MuiTab-root.Mui-selected': {
            color: '#2c4767',
        },
        '& .MuiTabs-indicator': {
            backgroundColor: '#b08d57',
            height: 3,
        },
        '& .MuiTab-wrapper > svg': {
            marginBottom: '4px !important',
        },
    },
    buttonPosition: {
        position: 'absolute',
        right: theme.spacing(3)
    },
    toolbarButtons: {
        marginLeft: 'auto',
        padding: 0,
        minHeight: 'auto',
    },
    sectionToolbar: {
        marginLeft: 'auto',
        padding: 0,
        minHeight: 'auto',
        gap: theme.spacing(1),
    },
    marginElement: {
        margin: 0,
    },
    marginTop: {
        marginTop: theme.spacing(4),
    },
    sectionDivider: {
        margin: theme.spacing(3, 0),
        background: 'linear-gradient(90deg, rgba(44, 71, 103, 0.18) 0%, rgba(176, 141, 87, 0.18) 100%)',
        height: 1,
    },
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(4),
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 12,
        border: '1px solid rgba(176, 141, 87, 0.18)',
        boxShadow: '0 2px 10px rgba(44, 71, 103, 0.06)',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
    mapContainer: {
        marginTop: theme.spacing(2),
        borderRadius: 10,
        overflow: 'hidden',
        border: '1px solid rgba(176, 141, 87, 0.18)',
    },
    mapFrame: {
        width: '100%',
        height: 320,
        border: 0,
        display: 'block',
    },
    notesField: {
        cursor: 'pointer',
        '& .MuiFormControl-root.MuiTextField-root': {
            cursor: 'pointer',
            background: 'linear-gradient(180deg, rgba(176, 141, 87, 0.08) 0%, rgba(247, 244, 238, 0.5) 100%)',
            borderColor: 'rgba(176, 141, 87, 0.35) !important',
        },
        '&:hover .MuiFormControl-root.MuiTextField-root': {
            background: 'rgba(176, 141, 87, 0.12)',
            borderColor: 'rgba(176, 141, 87, 0.55) !important',
        },
    },
    /* ---------- Read-only detail-view: turn TextFields into definition rows ---------- */
    detailView: {
        '& .MuiFormControl-root.MuiTextField-root': {
            margin: 0,
            marginBottom: 0,
            padding: theme.spacing(1.5, 2),
            background: '#fbfaf7',
            border: '1px solid rgba(176, 141, 87, 0.16)',
            borderRadius: 10,
            transition: 'border-color 150ms ease, background 150ms ease, box-shadow 150ms ease',
            width: '100%',
            boxSizing: 'border-box',
        },
        '& .MuiFormControl-root.MuiTextField-root:hover': {
            background: '#ffffff',
            borderColor: 'rgba(176, 141, 87, 0.35)',
            boxShadow: '0 2px 8px rgba(44, 71, 103, 0.04)',
        },
        // Label sits above as a small uppercase key, not as a floating MUI label
        '& .MuiInputLabel-root': {
            position: 'relative',
            transform: 'none !important',
            fontSize: '0.72rem',
            fontWeight: 800,
            letterSpacing: 1.3,
            textTransform: 'uppercase',
            color: '#2c4767',
            marginBottom: 6,
            display: 'block',
            pointerEvents: 'none',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#1f334a',
        },
        // Hide the standard variant underline
        '& .MuiInput-underline::before, & .MuiInput-underline::after': {
            display: 'none',
        },
        // Reset the InputBase wrapper so the value reads as plain prose
        '& .MuiInputBase-root': {
            marginTop: '0 !important',
            padding: 0,
            background: 'transparent',
            minHeight: 24,
        },
        '& .MuiInputBase-root.Mui-readOnly': {
            cursor: 'default',
        },
        // Value styling — readable, wraps long content naturally
        '& .Mui-readOnly input, & .Mui-readOnly textarea': {
            cursor: 'default',
            fontSize: '1rem',
            fontWeight: 600,
            color: '#111827',
            padding: 0,
            lineHeight: 1.55,
            WebkitTextFillColor: '#1a2733',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap',
        },
        // The space-eating adornment used as a date alignment hack — hide inside detail view
        '& .MuiInputAdornment-root': {
            display: 'none',
        },
    },
    detailHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
        flexWrap: 'wrap',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'stretch',
        },
    },
    detailHeaderText: {
        flex: '1 1 auto',
        minWidth: 0,
    },
    summaryCost: {
        background: 'linear-gradient(135deg, rgba(44, 71, 103, 0.06) 0%, rgba(176, 141, 87, 0.10) 100%)',
        padding: theme.spacing(2, 2.5),
        borderRadius: 10,
        border: '1px solid rgba(176, 141, 87, 0.22)',
        marginBottom: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        flexWrap: 'wrap',
    },
    summaryCostLabel: {
        color: '#5a6675',
        fontWeight: 600,
        fontSize: '0.95rem',
    },
    summaryCostValue: {
        color: '#2c4767',
        fontWeight: 700,
        fontSize: '1.6rem',
        letterSpacing: '-0.5px',
    },
    evidenceSectionHeading: {
        fontSize: '0.78rem',
        fontWeight: 700,
        letterSpacing: 1.2,
        textTransform: 'uppercase',
        color: '#5a6675',
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1.5),
        paddingBottom: theme.spacing(0.5),
        borderBottom: '1px solid rgba(176, 141, 87, 0.35)',
        '&:first-of-type': {
            marginTop: 0,
        },
    },
}));

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography component={'span'}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

// eslint-disable-next-line no-extend-native
Date.prototype.toShortFormat = function () {

    let monthNames = ["01", "02", "03", "04",
        "05", "06", "07", "08",
        "09", "10", "11", "12"];

    let day = this.getDate() < 10 ? `0${this.getDate()}` : this.getDate();

    let monthIndex = this.getMonth();
    let monthName = monthNames[monthIndex];

    let year = this.getFullYear();

    if (isNaN(this.getDate())) {
        return ''
    }

    return `${day}.${monthName}.${year}`;
}

// eslint-disable-next-line no-extend-native
Date.prototype.yyyyMMddFormat = function () {

    let monthNames = ["01", "02", "03", "04",
        "05", "06", "07", "08",
        "09", "10", "11", "12"];

    let day = this.getDate() < 10 ? `0${this.getDate()}` : this.getDate();

    let monthIndex = this.getMonth();
    let monthName = monthNames[monthIndex];

    let year = this.getFullYear();

    if (isNaN(this.getDate())) {
        return ''
    }

    return `${year}-${monthName}-${day}.`;
}

// eslint-disable-next-line no-extend-native
Date.prototype.timeFormat= function () {

    let minutes = this.getMinutes() < 10 ? `0${this.getMinutes()}` : this.getMinutes();
    let hours = this.getHours() < 10 ? `0${this.getHours()}` : this.getHours();

    if (isNaN(this.getDate())) {
        return ''
    }

    return `${hours}:${minutes}`;
}

// eslint-disable-next-line no-extend-native
Date.prototype.toShortFormatWithTimeExcel = function () {

    let monthNames = ["01", "02", "03", "04",
        "05", "06", "07", "08",
        "09", "10", "11", "12"];

    let dayNames = ["01", "02", "03", "04",
        "05", "06", "07", "08",
        "09", "10", "11", "12",
        "13", "14", "15", "16",
        "17", "18", "19", "20",
        "21", "22", "23", "24",
        "25", "26", "27", "28",
        "29", "30", "31"];

    let day = this.getDate();
    day = dayNames[day - 1];

    let monthIndex = this.getMonth();
    let monthName = monthNames[monthIndex];

    let year = this.getFullYear();

    let minutes = this.getMinutes() < 10 ? `0${this.getMinutes()}` : this.getMinutes();
    let hours = this.getHours() < 10 ? `0${this.getHours()}` : this.getHours();

    if (isNaN(this.getDate())) {
        return ''
    }

    return `${day}.${monthName}.${year} ${hours}:${minutes}`;
}

// Calculate age from birth and death dates
function calculateAge(birthDate, deathDate) {
    if (!birthDate || !deathDate) return '';
    
    const birth = new Date(birthDate);
    const death = new Date(deathDate);
    
    if (isNaN(birth.getTime()) || isNaN(death.getTime())) return '';
    
    let age = death.getFullYear() - birth.getFullYear();
    const monthDiff = death.getMonth() - birth.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && death.getDate() < birth.getDate())) {
        age--;
    }
    
    return age.toString();
}

function FuneralDetails(props) {
    const classes = useStyles();
    const access = getAccess();
    const fixedHeightPaper = clsx(classes.paper, classes.detailView);
    const [value, setValue] = useState(0);
    const [editNotes, setEditNotes] = useState(false);
    const [editDeceasedNotes, setEditDeceasedNotes] = useState(false);
    const [user, setuser] = useState(null);
    const [refetch, setRefetch] = useState(false);
    const [sharingFunus, setSharingFunus] = useState(false);
    const [funeral, setFuneral] = useState({
        contracting_authority: ' ',
        funeral_type: ' ',
        funeral_variant: ' ',
        ca_address: ' ',
        ca_zip: '',
        ca_city: '',
        ca_state: '',
        ca_nationality: '',
        ca_email: ' ',
        ca_phone: ' ',
        ca_id: ' ',
        ca_birth: ' ',
        ca_relationship: ' ',
        deceased: ' ',
        d_type: ' ',
        d_maiden_name: ' ',
        d_address: ' ',
        d_zip: ' ',
        d_city: ' ',
        d_state: ' ',
        d_place_birth: ' ',
        d_birth: null,
        d_death: null,
        d_place_death: ' ',
        d_id: ' ',
        d_gender: ' ',
        d_marital_status: ' ',
        d_nationality: ' ',
        d_education: ' ',
        d_last_job: ' ',
        d_wife_husband: ' ',
        d_wife_husband_id: ' ',
        planned_pickup_place: ' ',
        register_place: ' ',
        planned_pickup: null,
        town_funeral: ' ',
        place_funeral: ' ',
        date_funeral: null,
        coffin_arrival: null,
        coffin_arrival_place: ' ',
        urn_funeral_place: ' ',
        urn_funeral_date: null,
        picked_items: ' ',
        decease_photo: '',
        notes: ' ',
        deceased_notes: ' ',
        service_entities: [],
        product_entities: []
    });
    const [place, setPlace] = useState({
        cremation: ' ',
        new_monument: ' ',
        depth_hole: ' ',
        uncover_grave: ' ',
        cemetery: ' ',
        place_number: ' ',
        grave: ' ',
        who_is_buried: ' ',
        period_buried: ' ',
        covering_cement: ' ',
        exhumation: ' ',
        owner: ' ',
        google_maps_embed_url: ' '
    });
    const [evidence, setEvidence] = useState({
        items: ' ',
        placement_fridge: null,
        autopsy: ' ',
        d_dangerous_disease: ' ',
        car_id: ' ',
        temperature: ' ',
        disinfection: ' ',
        disinfection_date: null,
        employee: ' ',
        employee_money: ' ',
        employee_transfer: ' ',
        employee_clothes: ' ',
        employee_funeral: ' ',   
        placement_of_decedent: ' ',
        urn_number: ' ',
        cremation_datetime: null
    });
    const [confirmDialog, setConfirmDialog] = useState({isOpen: false, title: '', subTitle: ''})
    const [confirmDialogFun, setConfirmDialogFun] = useState({isOpen: false, title: '', subTitle: ''})
    const [redirects, setRedirects] = useState({
        list: false,
        editFuneral: false,
        editPlace: false,
        editServices: false,
        editProducts: false,
        editEvidence: false,
        createPlace: false,
        createEvidence: false

    });

    const [selectedFile, setSelectedFile] = useState({
        grave_hole_photo: null,
        grave_before_ceremony: null,
        grave_after_ceremony: null,
        grave_ceremony: null,
        grave_damage_1: null,
        grave_damage_2: null,
        grave_exterier_1: null,
        grave_exterier_2: null,
        grave_exterier_3: null,
        grave_exterier_4: null,
        grave_exterier_5: null,
        grave_exterier_6: null,
        grave_exterier_7: null,
        grave_exterier_8: null,
        grave_exterier_9: null,
        grave_exterier_10: null,
        deceased_takeover_photo_1: null,
        deceased_takeover_photo_2: null,
        deceased_takeover_photo_3: null,
        deceased_before_adjustment_photo_1: null,
        deceased_before_adjustment_photo_2: null,
        deceased_before_adjustment_photo_3: null,
        deceased_after_adjustment_photo_1: null,
        deceased_after_adjustment_photo_2: null,
        deceased_after_adjustment_photo_3: null,
    });

    const [progress, setProgress] = useState({
        grave_hole_photo: null,
        grave_before_ceremony: null,
        grave_after_ceremony: null,
        grave_ceremony: null,
        grave_damage_1: null,
        grave_damage_2: null,
        grave_exterier_1: null,
        grave_exterier_2: null,
        grave_exterier_3: null,
        grave_exterier_4: null,
        grave_exterier_5: null,
        grave_exterier_6: null,
        grave_exterier_7: null,
        grave_exterier_8: null,
        grave_exterier_9: null,
        grave_exterier_10: null,
        deceased_takeover_photo_1: null,
        deceased_takeover_photo_2: null,
        deceased_takeover_photo_3: null,
        deceased_before_adjustment_photo_1: null,
        deceased_before_adjustment_photo_2: null,
        deceased_before_adjustment_photo_3: null,
        deceased_after_adjustment_photo_1: null,
        deceased_after_adjustment_photo_2: null,
        deceased_after_adjustment_photo_3: null,
    });

    const [loaded, setLoaded] = useState({
        grave_hole_photo: null,
        grave_before_ceremony: null,
        grave_after_ceremony: null,
        grave_ceremony: null,
        grave_damage_1: null,
        grave_damage_2: null,
        grave_exterier_1: null,
        grave_exterier_2: null,
        grave_exterier_3: null,
        grave_exterier_4: null,
        grave_exterier_5: null,
        grave_exterier_6: null,
        grave_exterier_7: null,
        grave_exterier_8: null,
        grave_exterier_9: null,
        grave_exterier_10: null,
        deceased_takeover_photo_1: null,
        deceased_takeover_photo_2: null,
        deceased_takeover_photo_3: null,
        deceased_before_adjustment_photo_1: null,
        deceased_before_adjustment_photo_2: null,
        deceased_before_adjustment_photo_3: null,
        deceased_after_adjustment_photo_1: null,
        deceased_after_adjustment_photo_2: null,
        deceased_after_adjustment_photo_3: null,
    });

    const [isOpen, setIsOpen] = useState({
        grave_hole_photo: null,
        grave_before_ceremony: null,
        grave_after_ceremony: null,
        grave_ceremony: null,
        grave_damage_1: null,
        grave_damage_2: null,
        grave_exterier_1: null,
        grave_exterier_2: null,
        grave_exterier_3: null,
        grave_exterier_4: null,
        grave_exterier_5: null,
        grave_exterier_6: null,
        grave_exterier_7: null,
        grave_exterier_8: null,
        grave_exterier_9: null,
        grave_exterier_10: null,
        deceased_takeover_photo_1: null,
        deceased_takeover_photo_2: null,
        deceased_takeover_photo_3: null,
        deceased_before_adjustment_photo_1: null,
        deceased_before_adjustment_photo_2: null,
        deceased_before_adjustment_photo_3: null,
        deceased_after_adjustment_photo_1: null,
        deceased_after_adjustment_photo_2: null,
        deceased_after_adjustment_photo_3: null,
    });

    const [notes, setNotes] = useState('');
    const [deceasedNotes, setDeceasedNotes] = useState('');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleNotes = (e) => {
        setNotes(e.target.value);
    };

    const handleDeceasedNotes = (e) => {
        setDeceasedNotes(e.target.value);
    };

    const handleRedirects = (name) => {
        setRedirects({...redirects, [name]: true});
    }
    let user_local = JSON.parse(localStorage.getItem('user')).id;

    useEffect(() => {
        UserService.getFuneral(props.match.params.funeral_id).then(
            (response) => {
                const funeralData = {
                    ...response.data,
                    notes: response.data.notes || '',
                    deceased_notes: response.data.deceased_notes || ''
                };
                setFuneral(funeralData);
                if (response.data.place) setPlace(response.data.place);
                if (response.data.evidence) setEvidence(response.data.evidence);
                if (props.location.state.number) {
                    setValue(props.location.state.number);
                }
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                }
            }
        );
        UserService.getUser(user_local).then(
            (response) => {
                setuser(response.data)
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );

    }, [props, user_local, refetch]);

    const handleEditNotes = () => {
        UserService.editNotes({_id: funeral._id, notes: notes}).then(
            () => {
                NotificationManager.success('Poznámky upravené!', 'Upravené', 5000);
                setFuneral({...funeral, notes: notes});
                setNotes('');
                setEditNotes(false);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
                NotificationManager.error('Poznámky sa nepodarilo upraviť!', 'Chyba', 5000);
            }
        );
    }

    const handleEditDeceasedNotes = () => {
        UserService.editDeceasedNotes({_id: funeral._id, deceased_notes: deceasedNotes}).then(
            () => {
                NotificationManager.success('Poznámky k zosnulému upravené!', 'Upravené', 5000);
                setFuneral({...funeral, deceased_notes: deceasedNotes});
                setDeceasedNotes('');
                setEditDeceasedNotes(false);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
                NotificationManager.error('Poznámky k zosnulému sa nepodarilo upraviť!', 'Chyba', 5000);
            }
        );
    }

    const handleDelete = (id) => {
        setConfirmDialog({
            ...confirmDialog,
            isOpen: false
        })
        UserService.deleteFuneral(id).then(
            () => {
                NotificationManager.success('Pohreb bol presunutý do koša.', 'Presunuté', 5000);
                handleRedirects('list');
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
                NotificationManager.error('Pohreb sa nepodarilo odstrániť!', 'Chyba', 5000);
            }
        );
    }

    const createFunerioPost = async () => {
        if (sharingFunus) return;
        setConfirmDialogFun({...confirmDialogFun, isOpen: false});
        setSharingFunus(true);
        try {
            const response = await FunerioService.createFunerioFuneral(props.match.params.funeral_id);
            setFuneral(current => ({...current, funerio_id: response.data.id}));
            window.open(response.data.url, '_blank', 'noopener,noreferrer');
            NotificationManager.success('Pohreb bol zdieľaný na Funus.sk.', 'Zdieľané', 5000);
        } catch (error) {
            if (error.response?.status === 401) {
                logOut(props);
                NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
            } else {
                NotificationManager.error(error.response?.data?.error?.message ||
                    'Pohreb sa nepodarilo odoslať na Funus.sk.', 'Chyba', 5000);
            }
        } finally {
            setSharingFunus(false);
        }
    };

    const createFlowiiOrder = (funeral_id) => {
        setConfirmDialogFun({
            ...confirmDialogFun,
            isOpen: false
        })
        FlowiiService.createFlowiiOrder(funeral_id).then(
            (response) => {
                if (response.data?.url) {
                    window.open(response.data.url, '_blank');
                }
                if (response.data?.document_error) {
                    NotificationManager.warning('Objednávka bola vytvorená vo Flowii, ale doklad sa nepodarilo vytvoriť.', 'Upozornenie', 5000);
                    return;
                }
                NotificationManager.success('Objednávka bola vytvorená vo Flowii.', 'Vytvorené', 5000);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
                if(e.response.status === 400){
                    NotificationManager.warning('Ak sa toto hlásenie opakuje kontaktujte podporu.', 'Chyba', 5000);
                } else {
                    NotificationManager.error('Pohreb sa nepodarilo odoslať na flowii!', 'Chyba', 5000);
                }
            }
        );
    }

    const showValue = (item) => {
        if (item.text) {
            return item.text;
        }
        if (item.text_cost) {
            return `${item.text_cost.text} - ${item.text_cost.cost}`;
        }
        if (item.number) {
            return item.number;
        }
        if (item.yes_no !== undefined) {
            return item.yes_no ? 'Áno' : 'Nie';
        }
        return '';
    }

    const renderTextField = (id, label, value, props = {}) => (
        <Grid item xs={12} md={6} lg={4}>
            <TextField
                className={classes.marginElement}
                id={id}
                label={label}
                multiline
                value={value || ''}
                InputProps={{
                    readOnly: true,
                }}
                fullWidth={true}
                {...props}
            />
        </Grid>
    );

    const renderDateField = (id, label, value, withTime = false) => (
        <Grid item xs={12} md={6} lg={4}>
            <TextField
                className={classes.marginElement}
                id={id}
                label={label}
                multiline
                {...(value ? {
                        value: withTime ? new Date(value).toShortFormatWithTimeExcel() : new Date(value).toShortFormat()
                    } : {
                        value: ' '
                    }
                )}
                InputProps={{
                    readOnly: true,
                    startAdornment: <InputAdornment position="start"> </InputAdornment>,
                }}
                fullWidth={true}
            />
        </Grid>
    );

    const calculateCost = (entities) => {
        let sum = 0;
        entities.forEach(entity => {
            
            // Check if item should be included in cost calculation
            // Include if: count_cost is true OR (show_invoice is true and is not text_cost type)
            let shouldInclude = (entity.invoice_price && entity.show_invoice)|| entity.count_cost;
            
            if (shouldInclude) {
                // For non-text_cost items with show_invoice, use invoice_price
                if (entity.invoice_price && entity.show_invoice) {
                    sum += entity.invoice_price;
                } else {
                    // For text_cost items, use existing logic
                    if (entity.number) {
                        sum += entity.number;
                    }
                    if(entity.text_cost) {
                        sum += entity.text_cost.cost;
                    }
                }
            }
        })
        return sum;
    }

    const closeLightbox = (name) => () => {
        setIsOpen({ ...isOpen, [name]: !isOpen[name] });
    };

    const singleFileChangedHandler = (name) => (event) => {
        setSelectedFile({ ...selectedFile, [name]: event.target.files[0] });
        setLoaded({ ...loaded, [name]: "custom-file-upload-loaded" });
    };

    const handleProgress = (name) => (data) => {
        setProgress(current => ({
            ...current,
            [name]: data.total ? Math.round((100 * data.loaded) / data.total) : 0,
        }));
    };

    const saveImage = (url) => async () => {
        try { await downloadPrivateMedia(url); }
        catch (error) { NotificationManager.error(error.message, 'Súbor sa nepodarilo stiahnuť.', 5000); }
    };

    const substrOfName = (str) => {
        if (str.length > 12) {
            return (
                str.substr(0, 4) +
                "..." +
                str.substr(str.length - 8, str.length - 1)
            );
        }
        return str;
    };

    const documentCard = (photo, photoText, selectedFileForKey, title, method) => (
        <PhotoUploadCard
            key={photoText}
            photo={photo}
            photoText={photoText}
            selectedFile={selectedFileForKey}
            title={title}
            hint="Nahrajte fotku (max 20MB)"
            onFileChange={singleFileChangedHandler(photoText)}
            onUpload={method}
            onDownload={saveImage(photo)}
            isLightboxOpen={isOpen[photoText]}
            onToggleLightbox={closeLightbox(photoText)}
            uploadProgress={progress[photoText]}
        />
    );

    const deceasedPhotoGroups = [
        {
            title: 'Zosnulý pri prevzatí',
            photos: [
                ['deceased_takeover_photo_1', 'Fotka 1'],
                ['deceased_takeover_photo_2', 'Fotka 2'],
                ['deceased_takeover_photo_3', 'Fotka 3'],
            ],
        },
        {
            title: 'Zosnulý pred úpravou',
            photos: [
                ['deceased_before_adjustment_photo_1', 'Fotka 1'],
                ['deceased_before_adjustment_photo_2', 'Fotka 2'],
                ['deceased_before_adjustment_photo_3', 'Fotka 3'],
            ],
        },
        {
            title: 'Zosnulý po úprave',
            photos: [
                ['deceased_after_adjustment_photo_1', 'Fotka 1'],
                ['deceased_after_adjustment_photo_2', 'Fotka 2'],
                ['deceased_after_adjustment_photo_3', 'Fotka 3'],
            ],
        },
    ];

    const singleFileUploadHandler = (name) => async () => {
        const file = selectedFile[name];
        const validationError = validatePhotoFile(file);
        if (validationError) {
            NotificationManager.error(photoUploadErrorMessage(validationError), 'Chyba', 5000);
            return;
        }

        setProgress(current => ({...current, [name]: 0}));
        try {
            await UserService.addPhoto(photoFormData(file, funeral, name), handleProgress(name));
            setRefetch(current => !current);
            setLoaded(current => ({...current, [name]: ''}));
            setSelectedFile(current => ({...current, [name]: null}));
            NotificationManager.success('Dokument úspešne uložený!', 'Uložené', 5000);
        } catch (error) {
            if (error.response?.status === 401) {
                logOut(props);
                NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
            } else {
                NotificationManager.error(photoUploadErrorMessage(error), 'Chyba', 5000);
            }
        } finally {
            setProgress(current => ({...current, [name]: null}));
        }
    };


    const basicInfoView = () => {
        return (
            <>
                <Paper className={fixedHeightPaper}>
                    <Grid container>
                        {
                            user?.funerio_service_id &&
                            <Grid item>
                                <Toolbar>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        hidden={true}
                                        disabled={!access.write || sharingFunus}
                                        onClick={() => {
                                            setConfirmDialogFun({
                                                isOpen: true,
                                                title: 'Zdieľať pohreb na funus.sk?',
                                                subTitle: "Po súhlase sa otvorí nové okno www.funus.sk (ak sa nové okno neotvorilo," +
                                                    " skontrolujte si nastavenia prehliadača ohľadom vyskakovacích okien pre www.modernepohrebnictvo.sk)",
                                                onConfirm: createFunerioPost
                                            })
                                        }}
                                    >
                                        {sharingFunus ? 'Odosielam na Funus.sk…' : 'Zdieľať pohreb na Funus.sk'}
                                    </Button>
                                </Toolbar>
                            </Grid>
                        }
                        {
                            user?.flowii_company_id &&
                            <Grid item>
                                <Toolbar>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        hidden={true}
                                        onClick={() => {
                                            setConfirmDialogFun({
                                                isOpen: true,
                                                title: 'Vytvoriť objednávku vo Flowii?',
                                                subTitle: "",
                                                onConfirm: () => {
                                                    createFlowiiOrder(props.match.params.funeral_id);
                                                }
                                            })
                                        }}
                                    >
                                        Vytvoriť objednávku vo Flowii
                                    </Button>
                                </Toolbar>
                            </Grid>
                        }
                        <Grid item className={classes.toolbarButtons}>
                            <Toolbar>
                                {access.write && <ActionButton
                                    color="primary">
                                    <Tooltip title="Upraviť pohreb">
                                        <EditIcon
                                            fontSize="small"
                                            onClick={() => {
                                                handleRedirects('editFuneral');
                                            }}
                                        />
                                    </Tooltip>
                                </ActionButton>}
                                {access.deleteFuneral && <ActionButton

                                    color="secondary">
                                    <Tooltip title="Presunúť do koša">
                                        <DeleteIcon
                                            fontSize="small"
                                            onClick={() => {
                                                setConfirmDialog({
                                                    isOpen: true,
                                                    title: 'Presunúť tento pohreb do koša?',
                                                    subTitle: "Pohreb môžete neskôr obnoviť.",
                                                    onConfirm: () => {
                                                        handleDelete(funeral._id)
                                                    }
                                                })
                                            }}
                                        />
                                    </Tooltip>
                                </ActionButton>}

                            </Toolbar>
                        </Grid>
                    </Grid>

                    <Divider/>
                    <Box className={classes.marginTop}>
                        <Grid container className={classes.root} spacing={1}>
                            <Grid item xs={12} md={12} lg={12}>

                                <Tooltip title="Kliknúť pre úpravu">
                                    <div className={classes.notesField}>
                                        <TextField
                                            className={classes.marginElement}
                                            id="notes"
                                            label="Poznámky k pohrebu"
                                            multiline
                                            value={funeral.notes || ''}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            fullWidth={true}
                                            onClick={access.write ? () => {
                                                setEditNotes(true);
                                                setNotes(funeral.notes || '')
                                            } : undefined}
                                        />
                                    </div>
                                </Tooltip>
                            </Grid>
                        </Grid>
                        <Popup
                            title={'Úprava poznámok'}
                            openPopup={editNotes}
                            setOpenPopup={setEditNotes}
                            actions={<>
                                <Button color="primary" variant="outlined" onClick={handleEditNotes}>
                                    Uložiť
                                </Button>
                            </>}
                        >
                            <TextInput
                                label="Poznámky"
                                name={'notes'}
                                multiline
                                rows={10}
                                fullWidth
                                value={notes}
                                onChange={handleNotes}
                            />
                        </Popup>
                    </Box>
                    <Box className={classes.marginTop}>
                        <Title>Informácie o zosnulom</Title>
                        <Grid container className={classes.root} spacing={1}>
                            {renderTextField('deceased', 'Meno', funeral.deceased)}
                            {renderTextField('d_type', 'Typ zosnulého', funeral.d_type)}
                            {renderTextField('d_maiden_name', 'Rodné priezvisko', funeral.d_maiden_name)}
                            {renderTextField('d_age', 'Vek', calculateAge(funeral.d_birth, funeral.d_death))}
                            {renderTextField('d_gender', 'Pohlavie', funeral.d_gender)}
                            {renderTextField('d_nationality', 'Národnosť', funeral.d_nationality)}
                            {renderTextField('d_id', 'Rodné číslo', funeral.d_id)}
                            {renderTextField('d_address', 'Adresa', funeral.d_address)}
                            {renderTextField('d_zip', 'PSČ', funeral.d_zip)}
                            {renderTextField('d_city', 'Mesto', funeral.d_city)}
                            {renderTextField('d_state', 'Štát', funeral.d_state)}
                            {renderTextField('d_last_job', 'Posledné zamestnanie', funeral.d_last_job)}
                            {renderDateField('d_birth', 'Dátum narodenia', funeral.d_birth)}
                            {renderTextField('d_place_b', 'Miesto narodenia', funeral.d_place_birth)}
                            {renderTextField('d_place_death', 'Miesto úmrtia', funeral.d_place_death)}
                            {renderDateField('d_death', 'Dátum úmrtia', funeral.d_death)}
                            {renderTextField('d_marital_status', 'Rodinný stav', funeral.d_marital_status)}
                            {renderTextField('d_education', 'Vzdelanie', funeral.d_education)}
                            {renderTextField('d_wife_husband', 'Partner', funeral.d_wife_husband)}
                            {renderTextField('d_wife_husband_id', 'Rodné číslo partnera', funeral.d_wife_husband_id)}
                        </Grid>
                    </Box>
                    <Box className={classes.marginTop}>
                        <Title>Informácie o obstarávateľovi pohrebu</Title>
                        <Grid container className={classes.root} spacing={1}>
                            {renderTextField('contracting_authority', 'Meno', funeral.contracting_authority)}
                            {renderTextField('ca_id', 'Rodné číslo', funeral.ca_id)}
                            {renderTextField('ca_address', 'Adresa', funeral.ca_address)}
                            {renderTextField('ca_email', 'Email', funeral.ca_email)}
                            {renderTextField('ca_zip', 'PSČ', funeral.ca_zip)}
                            {renderTextField('ca_city', 'Mesto', funeral.ca_city)}
                            {renderTextField('ca_state', 'Štát', funeral.ca_state)}
                            {renderTextField('ca_nationality', 'Národnosť', funeral.ca_nationality)}
                            {renderTextField('ca_phone', 'Telefónne číslo', funeral.ca_phone)}
                            {renderTextField('ca_relationship', 'Príbuzenský vzťah', funeral.ca_relationship)}
                            {renderDateField('ca_birth', 'Dátum narodenia', funeral.ca_birth)}
                        </Grid>
                    </Box>
                    <Box className={classes.marginTop}>
                        <Title>Informácie o pohrebe</Title>
                        <Grid container className={classes.root} spacing={1}>
                            {renderDateField('planned_pickup', 'Plánované vyzdvihnutie', funeral.planned_pickup, true)}
                            {renderTextField('planned_pickup_place', 'Adresa plánovaného vyzdvihnutia', funeral.planned_pickup_place)}
                            {renderTextField('register_place', 'Matrika', funeral.register_place)}
                            {renderTextField('town_funeral', 'Mesto pohrebu', funeral.town_funeral)}
                            {renderTextField('place_funeral', 'Miesto pohrebu', funeral.place_funeral)}
                            {renderDateField('date_funeral', 'Dátum pohrebu', funeral.date_funeral, true)}
                            {renderDateField('coffin_arrival', 'Dátum príjazdu rakvy', funeral.coffin_arrival, true)}
                            {renderTextField('coffin_arrival_place', 'Adresa príjazdu rakvy', funeral.coffin_arrival_place)}
                            {renderTextField('funeral_type', 'Typ pohrebu', funeral.funeral_type)}
                            {renderTextField('funeral_variant', 'Druh pohrebu', funeral.funeral_variant)}
                            {renderTextField('picked_items', 'Prevzaté veci', funeral.picked_items)}
                            {renderTextField('urn_funeral_place', 'Miesto pohrebu urny', funeral.urn_funeral_place)}
                            {renderDateField('urn_funeral_date', 'Dátum a čas pohrebu urny', funeral.urn_funeral_date, true)}
                        </Grid>
                    </Box>

                </Paper>
                <ConfirmDialog
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                    icon={<DeleteIcon/>}
                />
                <ConfirmDialog
                    confirmDialog={confirmDialogFun}
                    setConfirmDialog={setConfirmDialogFun}
                    color = {'primary'}
                    icon={<ShareIcon/>}
                />

            </>
        )
    }
    const getMapEmbedUrl = (rawUrl) => {
        if (!rawUrl || typeof rawUrl !== 'string') return '';
        const trimmed = rawUrl.trim();
        if (!trimmed) return '';
        const lower = trimmed.toLowerCase();
        if (lower.includes('/maps/embed') || lower.includes('output=embed')) {
            return trimmed;
        }

        try {
            const url = new URL(trimmed);
            const q = url.searchParams.get('q') || url.searchParams.get('query');
            if (q) {
                return `https://www.google.com/maps?q=${encodeURIComponent(q)}&output=embed`;
            }
        } catch (e) {
            return '';
        }

        const latLngMatch = trimmed.match(/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
        if (latLngMatch) {
            return `https://www.google.com/maps?q=${latLngMatch[1]},${latLngMatch[2]}&output=embed`;
        }

        const placeMatch = trimmed.match(/\/place\/([^/]+)/);
        if (placeMatch && placeMatch[1]) {
            const placeName = decodeURIComponent(placeMatch[1].replace(/\+/g, ' '));
            return `https://www.google.com/maps?q=${encodeURIComponent(placeName)}&output=embed`;
        }

        const searchMatch = trimmed.match(/\/search\/([^/]+)/);
        if (searchMatch && searchMatch[1]) {
            const searchQuery = decodeURIComponent(searchMatch[1].replace(/\+/g, ' '));
            return `https://www.google.com/maps?q=${encodeURIComponent(searchQuery)}&output=embed`;
        }

        return '';
    };

    const placeView = () => {
        const mapInputUrl = (place.google_maps_embed_url || '').trim();
        const mapEmbedUrl = getMapEmbedUrl(mapInputUrl);
        const hasMapEmbed = Boolean(mapEmbedUrl);

        return (
            <>
                <Paper className={fixedHeightPaper}>
                    {access.write && <Toolbar className={classes.toolbarButtons}>
                        <ActionButton
                            color="primary">
                            <Tooltip title="Upraviť miesto pohrebu">
                                <EditIcon
                                    fontSize="small"
                                    onClick={() => {
                                        funeral.place ? handleRedirects('editPlace') : handleRedirects('createPlace');
                                    }}
                                />
                            </Tooltip>
                        </ActionButton>
                    </Toolbar>}
                    <Divider/>
                    <Box className={classes.marginTop}>
                        <Title>Informácie o pohrebnom mieste</Title>
                        <Grid container className={classes.root} spacing={1}>
                            {renderTextField('planned_pickup', 'Spopolnenie', place.cremation)}
                            {renderTextField('new_monument', 'Nový hrob', place.new_monument)}
                            {renderTextField('depth_hole', 'Hĺbka jamy', place.depth_hole)}
                            {renderTextField('grave', 'Hrobka', place.grave)}
                            {renderTextField('uncover_grave', 'Odkryť pomník s krycou doskou', place.uncover_grave)}
                            {renderTextField('covering_cement', 'Zaliatie panelov cementovou maltou', place.covering_cement)}
                            {renderTextField('cemetery', 'Cintorín', place.cemetery)}
                            {renderTextField('place_number', 'Číslo hrobového miesta', place.place_number)}
                            {renderTextField('who_is_buried', 'Pochovaní v hrobke', place.who_is_buried)}
                            {renderTextField('period_buried', 'Dĺžka pochovaného', place.period_buried)}
                            {renderTextField('exhumation', 'Exhumácia', place.exhumation)}
                            {renderTextField('owner', 'Majiteľ miesta', place.owner)}
                            <Grid item xs={12}>
                                <TextField
                                    className={classes.marginElement}
                                    id="google_maps_embed_url"
                                    label="Google Maps (odkaz alebo embed)"
                                    multiline
                                    value={place.google_maps_embed_url}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    fullWidth={true}
                                />
                                {hasMapEmbed ? (
                                    <Box className={classes.mapContainer}>
                                        <iframe
                                            title="Mapa pohrebného miesta"
                                            src={mapEmbedUrl}
                                            className={classes.mapFrame}
                                            allowFullScreen
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                        />
                                    </Box>
                                ) : null}
                                {!hasMapEmbed && mapInputUrl ? (
                                    <Box className={classes.mapContainer}>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            href={mapInputUrl}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Otvoriť mapu v novej karte
                                        </Button>
                                    </Box>
                                ) : null}
                            </Grid>
                        </Grid>
                        <Divider className={classes.sectionDivider}/>
                        <Box mt={3} mb={1}>
                            <Title>Fotky</Title>
                        </Box>
                        <Container className={classes.cardGrid} maxWidth="lg" disableGutters>
                            <Grid container spacing={3}>
                            {documentCard(
                                funeral.grave_hole_photo,
                                "grave_hole_photo",
                                selectedFile.grave_hole_photo,
                                "Výkop hrobu",
                                singleFileUploadHandler("grave_hole_photo")
                            )}
                            {documentCard(
                                funeral.grave_before_ceremony,
                                "grave_before_ceremony",
                                selectedFile.grave_before_ceremony,
                                "Hrob pred pohrebom",
                                singleFileUploadHandler("grave_before_ceremony")
                            )}
                            {documentCard(
                                funeral.grave_after_ceremony,
                                "grave_after_ceremony",
                                selectedFile.grave_after_ceremony,
                                "Hrob po pohrebe",
                                singleFileUploadHandler("grave_after_ceremony")
                            )}
                            {documentCard(
                                funeral.grave_ceremony,
                                "grave_ceremony",
                                selectedFile.grave_ceremony,
                                "Hrob počas pohrebu",
                                singleFileUploadHandler("grave_ceremony")
                            )}
                            {documentCard(
                                funeral.grave_damage_1,
                                "grave_damage_1",
                                selectedFile.grave_damage_1,
                                "Poškodenie hrobu 1",
                                singleFileUploadHandler("grave_damage_1")
                            )}
                            {documentCard(
                                funeral.grave_damage_2,
                                "grave_damage_2",
                                selectedFile.grave_damage_2,
                                "Poškodenie hrobu 2",
                                singleFileUploadHandler("grave_damage_2")
                            )}
                             {documentCard(
                                funeral.grave_exterier_1,
                                "grave_exterier_1",
                                selectedFile.grave_exterier_1,
                                "Okolie hrobu 1",
                                singleFileUploadHandler("grave_exterier_1")
                            )}
                             {documentCard(
                                funeral.grave_exterier_2,
                                "grave_exterier_2",
                                selectedFile.grave_exterier_2,
                                "Okolie hrobu 2",
                                singleFileUploadHandler("grave_exterier_2")
                            )}
                             {documentCard(
                                funeral.grave_exterier_3,
                                "grave_exterier_3",
                                selectedFile.grave_exterier_3,
                                "Okolie hrobu 3",
                                singleFileUploadHandler("grave_exterier_3")
                            )}
                             {documentCard(
                                funeral.grave_exterier_4,
                                "grave_exterier_4",
                                selectedFile.grave_exterier_4,
                                "Okolie hrobu 4",
                                singleFileUploadHandler("grave_exterier_4")
                            )}
                             {documentCard(
                                funeral.grave_exterier_5,
                                "grave_exterier_5",
                                selectedFile.grave_exterier_5,
                                "Okolie hrobu 5",
                                singleFileUploadHandler("grave_exterier_5")
                            )}
                             {documentCard(
                                funeral.grave_exterier_6,
                                "grave_exterier_6",
                                selectedFile.grave_exterier_6,
                                "Okolie hrobu 6",
                                singleFileUploadHandler("grave_exterier_6")
                            )}
                             {documentCard(
                                funeral.grave_exterier_7,
                                "grave_exterier_7",
                                selectedFile.grave_exterier_7,
                                "Okolie hrobu 7",
                                singleFileUploadHandler("grave_exterier_7")
                            )}
                             {documentCard(
                                funeral.grave_exterier_8,
                                "grave_exterier_8",
                                selectedFile.grave_exterier_8,
                                "Okolie hrobu 8",
                                singleFileUploadHandler("grave_exterier_8")
                            )}
                             {documentCard(
                                funeral.grave_exterier_9,
                                "grave_exterier_9",
                                selectedFile.grave_exterier_9,
                                "Okolie hrobu 9",
                                singleFileUploadHandler("grave_exterier_9")
                            )}
                             {documentCard(
                                funeral.grave_exterier_10,
                                "grave_exterier_10",
                                selectedFile.grave_exterier_10,
                                "Okolie hrobu 10",
                                singleFileUploadHandler("grave_exterier_10")
                            )}

                        </Grid>
            </Container>
                    </Box>
                </Paper>
            </>
        )
    }
    const deceasedView = () => {
        return (
            <>
                <Paper className={fixedHeightPaper}>
                    <Divider/>
                    <Box className={classes.marginTop}>
                        <Grid container className={classes.root} spacing={1}>
                            <Grid item xs={12}>
                                <Tooltip title="Kliknúť pre úpravu">
                                    <div className={classes.notesField}>
                                        <TextField
                                            className={classes.marginElement}
                                            id="deceased_notes"
                                            label="Poznámky k zosnulému"
                                            multiline
                                            value={funeral.deceased_notes || ''}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            fullWidth={true}
                                            onClick={access.write ? () => {
                                                setEditDeceasedNotes(true);
                                                setDeceasedNotes(funeral.deceased_notes || '')
                                            } : undefined}
                                        />
                                    </div>
                                </Tooltip>
                            </Grid>
                        </Grid>
                        <Popup
                            title={'Úprava poznámok k zosnulému'}
                            openPopup={editDeceasedNotes}
                            setOpenPopup={setEditDeceasedNotes}
                            actions={<>
                                <Button color="primary" variant="outlined" onClick={handleEditDeceasedNotes}>
                                    Uložiť
                                </Button>
                            </>}
                        >
                            <TextInput
                                label="Poznámky"
                                name={'deceased_notes'}
                                multiline
                                rows={10}
                                fullWidth
                                value={deceasedNotes}
                                onChange={handleDeceasedNotes}
                            />
                        </Popup>
                    </Box>
                    {deceasedPhotoGroups.map((group) => (
                        <Box className={classes.marginTop} key={group.title}>
                            <Title>{group.title}</Title>
                            <Container className={classes.cardGrid} maxWidth="lg" disableGutters>
                                <Grid container spacing={3}>
                                    {group.photos.map(([photoText, title]) => documentCard(
                                        funeral[photoText],
                                        photoText,
                                        selectedFile[photoText],
                                        title,
                                        singleFileUploadHandler(photoText)
                                    ))}
                                </Grid>
                            </Container>
                        </Box>
                    ))}
                </Paper>
            </>
        )
    }

    const productsView = () => {
        return (
            <>
                <Paper className={fixedHeightPaper}>
                    {access.write && <Toolbar className={classes.toolbarButtons}>
                        <ActionButton
                            color="primary">
                            <Tooltip title="Upraviť produkty pohrebu">
                                <EditIcon
                                    fontSize="small"
                                    onClick={() => {
                                        handleRedirects('editProducts');
                                    }}
                                />
                            </Tooltip>
                        </ActionButton>
                    </Toolbar>}

                    <Divider/>
                    <Box className={classes.marginTop}>
                        <Title>Informácie o produktoch</Title>
                        {access.seePrices && <div className={classes.summaryCost}>
                            <span className={classes.summaryCostLabel}>Informačná výsledná suma za zvolené produkty</span>
                            <span className={classes.summaryCostValue}>{calculateCost(funeral.product_entities)} €</span>
                        </div>}


                        <Grid container className={classes.root} spacing={1}>
                            {funeral.product_entities.map((item, index) =>
                                <Grid key={index} item xs={12} md={6} lg={4}>
                                    <TextField
                                        className={classes.marginElement}
                                        id={item.name}
                                        label={item.name}
                                        multiline
                                        fullWidth={true}
                                        value={showValue(item)}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                    />
                                </Grid>)}
                        </Grid>
                    </Box>
                </Paper>
            </>
        )
    }
    const servicesView = () => {
        return (
            <>
                <Paper className={fixedHeightPaper}>
                    {access.write && <Toolbar className={classes.toolbarButtons}>
                        <ActionButton
                            color="primary">
                            <Tooltip title="Upraviť služby pohrebu">
                                <EditIcon
                                    fontSize="small"
                                    onClick={() => {
                                        handleRedirects('editServices');
                                    }}
                                />
                            </Tooltip>
                        </ActionButton>
                    </Toolbar>}

                    <Divider/>
                    <Box className={classes.marginTop}>
                        <Title>Informácie o službách</Title>
                        {access.seePrices && <div className={classes.summaryCost}>
                            <span className={classes.summaryCostLabel}>Informačná výsledná suma za zvolené služby</span>
                            <span className={classes.summaryCostValue}>{calculateCost(funeral.service_entities)} €</span>
                        </div>}
                        <Grid container className={classes.root} spacing={1}>
                            {funeral.service_entities.map((item, index) =>
                                <Grid key={index} item xs={12} md={6} lg={4}>
                                    <TextField
                                        className={classes.marginElement}
                                        id={item.name}
                                        label={item.name}
                                        multiline
                                        fullWidth={true}
                                        value={showValue(item)}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                    />
                                </Grid>)}
                        </Grid>
                    </Box>
                </Paper>
            </>
        )
    }
    const evidenceView = () => {
        return (
            <>
                <Paper className={fixedHeightPaper}>
                    {access.write && <Toolbar className={classes.toolbarButtons}>
                        <ActionButton
                            color="primary">
                            <Tooltip title="Upraviť evidenciu pohrebu">
                                <EditIcon
                                    fontSize="small"
                                    onClick={() => {
                                        funeral.evidence ? handleRedirects('editEvidence') : handleRedirects('createEvidence');
                                    }}
                                />
                            </Tooltip>
                        </ActionButton>
                    </Toolbar>}

                    <Divider/>
                    <Box className={classes.marginTop}>
                        <Title>Informácie o dátach pre evidenciu</Title>

                        <div className={classes.evidenceSectionHeading}>Doklady a stav</div>
                        <Grid container className={classes.root} spacing={1}>
                            {renderTextField('items_evidence', 'Odovzdané doklady a osobné veci', evidence.items)}
                            {renderTextField('autopsy', 'Pitva', evidence.autopsy)}
                            {renderTextField('d_dangerous_disease', 'Úmrtie na nebezpečnú chorobu', evidence.d_dangerous_disease)}
                            {renderDateField('placement_fridge', 'Dátum a čas uloženia do chladiaceho zariadenia', evidence.placement_fridge, true)}
                            {renderTextField('car_id', 'ŠPZ prepravujúceho vozidla', evidence.car_id)}
                            {renderTextField('temperature', 'Teplota v chladiarenskom zariadení', evidence.temperature)}
                            {renderTextField('disinfection', 'Čistenie a dezinfekcia chladiaceho zariadenia a vozidla', evidence.disinfection)}
                            {renderDateField('disinfection_date', 'Dátum a čas - čistenie a dezinfekcia chladiaceho zariadenia a vozidla', evidence.disinfection_date, true)}
                        </Grid>

                        <div className={classes.evidenceSectionHeading}>Zamestnanci</div>
                        <Grid container className={classes.root} spacing={1}>
                            {renderTextField('employee', 'Kto vybavuje pohreb (zamestnanec)', evidence.employee)}
                            {renderTextField('employee_money', 'Kto prevzal peniaze za pohreb (zamestnanec)', evidence.employee_money)}
                            {renderTextField('employee_transfer', 'Kto bol po zosnulého (zamestnanec)', evidence.employee_transfer)}
                            {renderTextField('employee_clothes', 'Kto obliekal zosnulého (zamestnanec)', evidence.employee_clothes)}
                            {renderTextField('employee_funeral', 'Kto bol na pohrebe (zamestnanec)', evidence.employee_funeral)}
                        </Grid>

                        <div className={classes.evidenceSectionHeading}>Uloženie a kremácia</div>
                        <Grid container className={classes.root} spacing={1}>
                            {renderTextField('placement_of_decedent', 'Miesto, kde sú uložené ľudské ostatky pred pohrebom', evidence.placement_of_decedent)}
                            {renderTextField('urn_number', 'Číslo urny', evidence.urn_number)}
                            {renderDateField('cremation_datetime', 'Dátum a čas kremácie', evidence.cremation_datetime, true)}
                        </Grid>
                    </Box>
                </Paper>
            </>
        )
    }
    const documentsView = () => {
        return (
            <>
                <Paper className={fixedHeightPaper}>
                    <DocumentsDetails {...props} funeral={funeral} setRefetch={setRefetch} refetch={refetch}/>
                </Paper>
            </>
        )
    }

    const tasksView = () => {
        return (
            <>
                <TaskDetails {...props} funeral={funeral} setRefetch={setRefetch} refetch={refetch}/>
            </>
        )
    }

    return (
        <>
            <Container maxWidth="lg" className={classes.seeMore}>
                <div className={classes.root}>
                    <AppBar position="static" elevation={0} color="default" className={classes.tabsBar}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab label="Základné informácie" icon={<PermIdentityIcon/>} {...a11yProps(0)} />
                            <Tab label="Pohrebné miesto" icon={<PlaceIcon/>} {...a11yProps(1)} />
                            <Tab label="Služby pohrebu" icon={<SettingsApplicationsIcon/>} {...a11yProps(2)} />
                            <Tab label="Produkty pohrebu" icon={<AllInboxIcon/>} {...a11yProps(3)} />
                            <Tab label="Evidencia" icon={<StorageIcon/>} {...a11yProps(4)} />
                            <Tab label="Dokumenty" icon={<DescriptionIcon/>} {...a11yProps(5)} />
                            <Tab label="Zosnulý" icon={<PersonIcon/>} {...a11yProps(6)} />
                            <Tab label="Úlohy" icon={<AssignmentIcon/>} {...a11yProps(7)} />
                        </Tabs>
                    </AppBar>
                    <TabPanel value={value} index={0}>
                        {basicInfoView()}
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        {placeView()}
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        {servicesView()}
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        {productsView()}
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                        {evidenceView()}
                    </TabPanel>
                    <TabPanel value={value} index={5}>
                        {documentsView()}
                    </TabPanel>
                    <TabPanel value={value} index={6}>
                        {deceasedView()}
                    </TabPanel>
                    <TabPanel value={value} index={7}>
                        {tasksView()}
                    </TabPanel>
                </div>
            </Container>
            {redirects.editFuneral ? <Redirect to={{
                pathname: `/pohreb/${funeral._id}/upravit`,
                state: {from: props.location}
            }}/> : <></>}
            {redirects.list ? <Redirect to={{
                pathname: `/zoznam`,
                state: {from: props.location}
            }}/> : <></>}
            {redirects.editPlace ? <Redirect to={{
                pathname: `/pohreb/miesto/${funeral._id}/${funeral.place._id}`,
                state: {from: props.location}
            }}/> : <></>}
            {redirects.editProducts ? <Redirect to={{
                pathname: `/pohreb/produkty/${funeral._id}`,
                state: {from: props.location}
            }}/> : <></>}
            {redirects.editServices ? <Redirect to={{
                pathname: `/pohreb/sluzby/${funeral._id}`,
                state: {from: props.location}
            }}/> : <></>}
            {redirects.editEvidence ? <Redirect to={{
                pathname: `/pohreb/evidencia/${funeral._id}/${funeral.evidence._id}`,
                state: {from: props.location}
            }}/> : <></>}
            {redirects.createPlace ? <Redirect to={{
                pathname: `/pohreb/${funeral._id}/miesto`,
                state: {from: props.location}
            }}/> : <></>}
            {redirects.createEvidence ? <Redirect to={{
                pathname: `/pohreb/${funeral._id}/evidencia`,
                state: {from: props.location}
            }}/> : <></>}
        </>
    );
}

export default withWidth()(FuneralDetails)
